import { createSlice } from '@reduxjs/toolkit';
import { MODALS_KEYS } from '_constants/modals';

const modalsSlice = createSlice({
  name: 'modals',
  initialState: {
    visibility: {
      [MODALS_KEYS.requestFailed]: false,
      [MODALS_KEYS.paymentFailed]: false,
      [MODALS_KEYS.packageEdit]: false,
      [MODALS_KEYS.bundleEdit]: false,
      [MODALS_KEYS.packageUpgrade]: false,
      [MODALS_KEYS.productRemovalConfirm]: false,
      [MODALS_KEYS.registeredAgentRemovalConfirmPrimary]: false,
      [MODALS_KEYS.registeredAgentRemovalConfirmSecondary]: false,
      [MODALS_KEYS.duplicatedMemberConfirm]: false,
    },
    data: {
      [MODALS_KEYS.requestFailed]: {},
      [MODALS_KEYS.paymentFailed]: {},
      [MODALS_KEYS.packageEdit]: {},
      [MODALS_KEYS.bundleEdit]: {},
      [MODALS_KEYS.packageUpgrade]: {},
      [MODALS_KEYS.productRemovalConfirm]: {},
      [MODALS_KEYS.registeredAgentRemovalConfirmPrimary]: {},
      [MODALS_KEYS.registeredAgentRemovalConfirmSecondary]: {},
      [MODALS_KEYS.duplicatedMemberConfirm]: {},
    },
  },
  reducers: {
    showModal(state, action) {
      state.visibility = {
        ...state.visibility,
        [action.payload.key]: true,
      };

      state.data = {
        ...state.data,
        [action.payload.key]: action.payload.data || {},
      };
    },
    hideModal(state, action) {
      state.visibility = {
        ...state.visibility,
        [action.payload.key]: false,
      };

      state.data = {
        ...state.data,
        [action.payload.key]: action.payload.data || {},
      };
    },
  },
});

export const { showModal, hideModal } = modalsSlice.actions;

export default modalsSlice.reducer;
